import { ArrowUpRight } from 'lucide-react'

interface VisitSiteButtonProps {
  url: string
  variant?: 'light' | 'dark'
}

/**
 * Button to visit an external site, used in card overlays.
 * Opens in a new tab with security attributes.
 */
export function VisitSiteButton({ url, variant = 'light' }: VisitSiteButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const buttonClass = variant === 'dark'
    ? 'flex items-center gap-2 px-4 py-2.5 rounded-full shadow-lg transition-all hover:scale-105 bg-white/10 text-white hover:bg-white/20'
    : 'flex items-center gap-2 px-4 py-2.5 rounded-full shadow-lg transition-all hover:scale-105 bg-white/90 backdrop-blur text-black hover:bg-white'

  return (
    <button
      onClick={handleClick}
      className={buttonClass}
      title="Visit site"
    >
      <ArrowUpRight className="h-4 w-4" />
      <span className="text-xs font-bold">Visit site</span>
    </button>
  )
}
